import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const CheckSmallIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 17 17" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.008 3.04137C15.4323 3.39494 15.4896 4.0255 15.1361 4.44978L8.46959 12.4496C8.28973 12.6654 8.02736 12.7956 7.74669 12.8084C7.46601 12.8211 7.19293 12.7152 6.99426 12.5165L2.99406 8.5163C2.60354 8.12578 2.60354 7.49261 2.99407 7.10209C3.38459 6.71156 4.01775 6.71156 4.40828 7.10209L7.63417 10.328L13.5996 3.16941C13.9532 2.74514 14.5837 2.68781 15.008 3.04137Z"
            />
        </SvgIcon>
    );
};

export default CheckSmallIcon;
